import { registerPlugin } from '@capacitor/core'

/** The installed Android shell's permission-free system pickers. */
export const AndroidFiles = registerPlugin<{
  pickContact(): Promise<{ name?: string; email?: string; cancelled?: boolean }>
  saveFile(options: {
    path: string
    name: string
    mediaType: string
  }): Promise<{ cancelled: boolean }>
  setSystemBars(options: { dark: boolean; background: string }): Promise<void>
}>('AndroidFiles')

export function isAndroidApp(): boolean {
  const capacitor = (globalThis as { Capacitor?: { getPlatform?: () => string } }).Capacitor
  return capacitor?.getPlatform?.() === 'android'
}
